import React from 'react'
import { StyleSheet, View} from 'react-native'

import { Anchor } from '@sart/components'
import { colors } from '@sart/styles'

import { useContent } from '@sart/content'

export default function NeedHelpFooter(props) {
  
  const content = useContent()


  return (
    <View style={styles.container}>
      <Anchor
        style={styles.anchor}
        title={content.common.help}
        {...props}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    height: 72,
    alignItems: 'center',
    justifyContent: 'center',
    },
  anchor: {
    color: colors.black,
    fontWeight: '500',
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 48,
    paddingRight: 48
  }
})
